/* eslint-disable react/jsx-key */
/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import React from 'react'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
import { ContentData } from '../../common/Interview/fragments/type'

const sectionTitle = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/nagoyatv/Interview_1.webp',
      alt: 'インタビュー写真',
      text: '右から名古屋テレビ放送株式会社 コンテンツビジネス局 プロデューサー 藤石崇文さん、名古屋テレビネクスト株式会社 取締役 経営戦略部長 荻原悦子さん、AitriaのxRコミュニケーションデザイン部 マネージャー 村上。',
    },
    {
      type: 'textBox',
      texts: [
        '名古屋テレビ放送株式会社は、「メ〜テレ」の愛称で親しまれている1961年創立のテレビ朝日系列のテレビ局です。',
        "Aitriaは、名古屋テレビ放送株式会社の「Nex'BN」チームと共同で、「『キャンプ場の歩き方』をデジタルで再現するには？」をテーマとしたトライアルプロジェクト「いつでもどこでもハピキャン　～メタバースはじめてみました～」を開発しました。",
        'メタバースコンテンツ開発に込めた思い、そして制作プロジェクトとその進行について、名古屋テレビ放送株式会社コンテンツビジネス局プロデューサーの藤石崇文さん、名古屋テレビネクスト株式会社取締役経営戦略部長の荻原悦子さん、そして名古屋テレビ放送株式会社技術局設備戦略部の小林晋尚さんにお話を伺いました。',
      ],
      wide: true,
      bold: false,
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: '「2030年の未来」を見据えたトライアルプロジェクト',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/nagoyatv/Interview_2.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― プロジェクトの概要を教えてください。'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        '名古屋テレビ放送では、「2030年ごろに社会がどうなっているのか」を大きなテーマとして、未来の名古屋テレビ放送（NBN）像を模索する「Nex’BN」というプロジェクトを毎年立ち上げています。この「Nex’BN」では都度メンバーチェンジを行いながら、有識者へのヒアリングや、それを踏まえたディスカッションとトライアルを続けており、その2023年の取り組みが今回のプロジェクトとなりました。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― プロジェクトのパートナーとしてAitriaを選ばれたきっかけは？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        '以前、村上さんのウェビナーを聴講した際、本当に深い知識をお持ちなのに初心者に向けての説明がすごく分かりやすかったんです。そこで今回の「Nex’BN」における有識者へのヒアリングフェーズでは、まず村上さんに「xRやメタバース」についてのお話を伺いたいと思いました。「Nex’BN」では3チームに分かれてヒアリングを行っていたのですが、各チームのリサーチ結果を総合して2030年に向けてのトライアルを行うこととなり、村上さんと一緒にメタバース分野でのトライアルをさせていただきたいとお願いし、お付き合いが始まりました。',
      ],
    },
    {
      type: 'textBox',
      texts: ['―― 企画・開発はどのようなところからスタートしたのでしょうか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '村上',
      texts: [
        'メタバースにおいては、やりたいことを実現するためにどういうプラットフォームを選ぶかが重要です。そのため最初に「どういうことをされたいですか？」と、結構しつこくお伺いしました。また、メタバースは時間と予算をかければ何でもできてしまう領域ですので、ご予算等の都合もしっかりとお伺いし、それらの条件を踏まえて企画を提案させていただきました。',
      ],
    },
    {
      type: 'textBox',
      texts: ['――メタバース上での「キャンプ」という方向性はどのように決まったのでしょうか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        <p>
          我々がメタバースをやる以上、名古屋テレビならではの世界観があった方が良いと考え、弊社が運営するビッグコンテンツである複合型アウトドア情報発信メディア「ハピキャン」（
          <a href="https://happycamper.jp/" rel="noopener noreferrer" target="_blank">
            https://happycamper.jp/
          </a>
          ）で展開することになりました。そこからは自然と「メタバースでキャンプをやろう」が共通認識となっていましたね。
        </p>,
      ],
    },
    {
      type: 'greyBox',
      name: '藤石さん',
      texts: [
        '従来のテレビ局といえば、一方的にマスに情報を届けるメディアでした。しかし、これからの時代はファンの方々と双方向のコミュニケーションが不可欠です。そのためユーザーの皆さんとコミュニケーションが取れるコンテンツであることは、一つの命題だったと思います。キャンプにおいて「焚き火の前だと正直に話せちゃう」といったことがよく語られます。それと同じようなことをデジタル空間で再現できるかどうか、そこでユーザー同士がどういうコミュニケーションを行うかを注視することがトライアルの大きな目的の一つとなりました。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: 'メタバース構築に最適化したプロジェクト進行',
    },
    {
      type: 'textBox',
      texts: [
        '―― メタバースコンテンツとなると、通常のWebサイトやアプリ開発とは異なるプロセスが求められると思います。プロジェクト進行の工夫はありましたか？',
      ],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '村上',
      texts: [
        'まず「やりたいことをできるだけ可視化する」ことを優先しました。というのも、実はメタバース空間を使った企画を二次元の資料に落とし込むのはとても難しいんです。とくに今回はメ〜テレさんにとってほぼ初めてのメタバースということもあり、できる限りイメージがしやすい内容を心がけた画像と文章を準備し、その上で実際に動くサンプルをご覧いただきながら企画を詰めていきました。',
        'また、今回は「ハピキャン」のファンの方々が中心のコンテンツになることは分かっていましたので、ファンの方々のプロフィールやペルソナについては念入りにヒアリングを行いました。彼らがアクセスする手段としてPCブラウザを選ぶことが多いであろうと判断し、予算やスケジュール、集客目標から逆算してプラットフォーム選定をご提案いたしました。それら候補となる各プラットフォームにおけるメリット／デメリットを全て並べた上で、今回は北米のスタートアップ企業のプラットフォーム「Spatial」を採用・決定いただきました。基本的に国内の事例では国産プラットフォームを選ばれる風潮が強いのですが、今回は「Spatial」を選択いただいたことで品質が良いものができたと思っています。',
      ],
    },
    {
      type: 'greyBox',
      name: '小林さん',
      texts: [
        '私はメ〜テレ内の別プロジェクトで以前もメタバースの試みを担当していたのですが、今回は以前よりもリッチなコンテンツを表現できるプラットフォームを選びたいという思いもあり、いろいろ比較検討させていただいた中でご提案いただいた「Spatial」を採用させていただきました。',
      ],
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/nagoyatv/Interview_3.webp',
      alt: 'インタビュー写真',
      text: '今回、リモートでインタビューに答えてくださった名古屋テレビ放送株式会社 技術局 設備戦略部の小林晋尚さん',
    },
    {
      type: 'greyBox',
      name: '村上',
      texts: [
        '詳しくお話を伺って、「それを実現するためにはこういう手段があります」と、いくつもの選択肢をご提示できるのが私たちAitriaの強みだと思っていますので、まずは徹底的にお話をさせていただくことを重視しています。',
      ],
    },
    {
      type: 'greyBox',
      name: '小林さん',
      texts: [
        'また、「Nex’BN」は社内横断プロジェクトということで、兼務している仕事の影響から、村上さんのご質問になかなかお答えできない時期も正直ありました。しかし、村上さんのチームの皆さんはBacklogを使ったスケジュール管理を行い、しっかりとプッシュを続けていただいたおかげで、こうして滞りなくスムーズに進行できたと思って感謝しています。',
      ],
    },
  ],
  [
    {
      type: 'sectionTitle',
      text: 'メタバース挑戦の手応えと、それぞれが描くメ〜テレの未来',
    },
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/nagoyatv/Interview_4.webp',
      alt: 'インタビュー写真',
    },

    {
      type: 'textBox',
      texts: ['―― 実際にメタバースを展開していかがでしたか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        '一言で言えば「楽しかった」です（笑）。村上さんのチームの中に「ハピキャン」をご存知の方がいらっしゃったこともあって、自主的に「ハピキャンならこういうのはいかがですか？」とご提案いただくことも多く、とてもスムーズに進行いただけたと思っています。',
      ],
    },
    {
      type: 'greyBox',
      name: '村上',
      texts: [
        '言葉を選ばずにいえば、今回はトライアルということも含め「メタバースってこれくらいのものですよ」と実感していただくのも一つの目的だったと考えています。WebやSNSといったチャンネルの一つとして、今後テレビ局がメタバースをどのように使っていけばいいかという手応えは感じていただけたのではないかと思っています。',
      ],
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        'まさに「（現時点では）これくらいのことができるよね」という、現在のメタバースでできることを感じることができました。例えば、通信環境やデバイスの性能などがバラバラであるが故の外部要因を感じる点もありました。それらを含めて現在のメタバースを掴めたと思っています。そして今後の環境改善によって、一気にブレイクスルーが行われるだろうとも感じています。',
      ],
    },
    {
      type: 'greyBox',
      name: '藤石さん',
      texts: [
        '私も同じく「今はメタバースでこれくらいのことができる」と思えたのが一番大きい成果だと感じています。',
        'とはいえ、それは決してネガティブな意味合いではなく、ちょっと遠い未来の存在だと思っていたメタバースを身近なコンテンツとして捉えられるようになったという点でポジティブに捉えています。実際、今後はメタバース活用のアイディアを出していけそうだなという感触もあり、新しい武器を得られたと感じています。',
      ],
    },
    {
      type: 'greyBox',
      name: '小林さん',
      texts: [
        'まさに「やってみて分かったこと」がすごく多いプロジェクトでしたね。同時接続の問題とか、スパム的な書き込みへの対応だとか、マーケティング的な部分でも得られるものが多く、次に繋がる大きな成果が得られたトライアルだったと感じています。',
      ],
    },
    {
      type: 'greyBox',
      name: '藤石さん',
      texts: [
        'メタバース内のイベントにおけるユーザーの方々の反応も印象的でしたね。ハピキャン公式YouTubeチャンネルのオリジナル企画「山口トンボ、キャンプ始めます」に出演中の放送作家・山口トンボさんと奥様・りおさんがYouTube生配信を行うというイベントを行ったのですが、当日はすごく多くの方に「ニックネームを呼んでもらった」「挨拶できた」「楽しかった」と楽しんでもらえたんです。イベント自体は1時間限定だったのですが、生配信が終わった後もユーザー同士で生配信の感想を話し合うコミュニケーションが行われていて、それはメタバースならではのものだと感じました。',
      ],
    },
  ],
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/nagoyatv/Interview_5.webp',
      alt: 'インタビュー写真',
    },
    {
      type: 'textBox',
      texts: ['―― 最後に今後のメ〜テレの展望についてお伺いできますか？'],
      wide: false,
      bold: true,
    },
    {
      type: 'greyBox',
      name: '小林さん',
      texts: [
        '私たちは「共創メディア」としてどんどん新しい取り組みを行い、一方的なマスに対する放送だけでなくデジタルツールを使って双方向のコミュニケーションを促進していきたいと考えています。そのためにはxRやメタバースはこれから重要な技術の一つであると考えています。',
      ],
    },
    {
      type: 'greyBox',
      name: '萩原さん',
      texts: [
        'そうですね。一方的に情報を提供する従来型のテレビメディアとしてではなく、各番組のファンの人たちと一緒にコンテンツの価値を高め、より良い未来に繋げていく「共創」においては、xRやメタバースは不可欠となるはずです。',
      ],
    },
    {
      type: 'greyBox',
      name: '藤石さん',
      texts: [
        'これまでの各プロジェクトは一つのゴール、「放送」に向かって進行してきました。しかし今後は放送だけをゴールとするのではなく、イベントやオンラインコミュニティー、YouTubeやTikTok、そしてxRやメタバースも一つの手段として活用していくことを、引き続き検討していきたいと思っています。',
      ],
    },
  ],
]

gsap.registerPlugin(ScrollTrigger)
const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>(null)
  const image = useRef<HTMLImageElement>(null)
  const text_container = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (image.current && text_container.current) {
      timeline.from(image.current, tweenVars, 0.2)
      timeline.from(text_container.current, tweenVars, 0.4)

      ScrollTrigger.create({
        animation: timeline,
        trigger: wrapper.current,
        start: 'top-=100 80%',
        toggleActions: 'play none none reverse',
      })
    }
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
